/** @format */

import { Box, Image, Text } from "@chakra-ui/react";
import runes from "runes";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { validaValidadede } from "../../../utils";
import { BoxVigencia } from "../../CardComponents/BoxVigencia";
import { CardHeader } from "../../CardComponents/CardHeader";
import { Container } from "../../CardComponents/Container";
import { ContentPrice } from "../../CardComponents/ContentPrice";
import { Observacao } from "../../CardComponents/Observacao";
import { ShareButton } from "../../CardComponents/ShareButton";
import { TextValidade } from "../../CardComponents/TextValidade";

export function CardOfertaHorizontal({ props, onClickCard }) {
  const {
    // HEADER
    id_classificacao_topete,
    idtiporecomendacao,

    // PRODUTO
    nomeoferta,
    valorde,
    percentualdesconto,
    valorpor,
    quantidadeparcelas,
    valorparcelas,
    ofertagenerica,
    observacao,

    // VALIDADE
    validade,
    validadede,

    // IMAGENS
    imagem,
    selopromocao,
    seloClube,

    // ESTADO
    clube = false,
    validoapartir = validaValidadede({
      validadede: props.validadede,
    }),
  } = props;

  const {
    personalizacao: { card },
  } = usePersonalizacao();

  const getCorBgDestaqueSelo = () => {
    if (idtiporecomendacao === "1") {
      return card?.descontoexclusivo?.cordestaque
        ? card?.descontoexclusivo?.cordestaque
        : card?.cordestaque;
    }
    if (idtiporecomendacao === "2") {
      return card?.tabloide?.cordestaque
        ? card?.tabloide?.cordestaque
        : card?.cordestaque;
    }
    if (idtiporecomendacao === "3") {
      return card?.cashback?.cordestaque
        ? card?.cashback?.cordestaque
        : card?.cordestaque;
    }
  };

  return (
    <Container
      horizontal
      props={{
        validoapartir: validoapartir,
        clube: clube,
        idtiporecomendacao: idtiporecomendacao,
      }}>
      <Box cursor="pointer">
        <CardHeader
          props={{
            id_classificacao_topete: id_classificacao_topete,
            validadede: validadede,
            clube: clube,
            idtiporecomendacao: idtiporecomendacao,
          }}
        />

        <Box padding="0.5rem">
          <Box
            onClick={onClickCard}
            display="flex"
            flexDir="row"
            justifyContent="flex-start">
            <Box filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
              <Image
                objectFit="contain"
                width="104px"
                height="104px"
                src={imagem}
              />
            </Box>

            {/* ContainerTextProduto */}
            <Box marginLeft="1rem" flexShrink="1">
              <Box
                whiteSpace="normal"
                paddingTop="0.5rem"
                paddingBottom="0.25rem">
                <Text fontSize="0.75rem" color="#3E4047" fontWeight="black">
                  {nomeoferta.length > 40
                    ? runes.substr(nomeoferta, 0, 40) + "..."
                    : nomeoferta.length <= 40
                    ? `${nomeoferta}`
                    : nomeoferta}
                </Text>
              </Box>
              <ContentPrice
                oferta
                isHorizontal
                props={{
                  valorde: valorde,
                  valorpor: valorpor,
                  percentualdesconto: percentualdesconto,
                  validadede: validadede,
                  quantidadeparcelas: quantidadeparcelas,
                  valorparcelas: valorparcelas,
                }}
              />
              <TextValidade ofertas props={{ validade: validade }} />
              {observacao && <Observacao observacao={observacao} />}
            </Box>
          </Box>
          {!validoapartir ? (
            <Box
              display="flex"
              flexDir="row"
              marginTop="0.5rem"
              alignItems="center"
              justifyContent="space-between">
              <Box
                display="flex"
                flexDir="row"
                alignItems="center"
                filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
                {selopromocao ? (
                  <Box
                    background={clube ? getCorBgDestaqueSelo : "transparent"}
                    marginLeft="-0.5rem"
                    paddingY="0.25rem"
                    paddingX="0.30em"
                    borderTopRightRadius="md"
                    borderBottomRightRadius="md">
                    <Image
                      objectFit="contain"
                      w="40px"
                      h="40px"
                      src={selopromocao}
                    />
                  </Box>
                ) : !selopromocao && seloClube ? (
                  <Box
                    background={clube ? getCorBgDestaqueSelo : "transparent"}
                    marginLeft="-0.5rem"
                    paddingY="0.25rem"
                    paddingX="0.30em"
                    borderTopRightRadius="md"
                    borderBottomRightRadius="md">
                    <Image
                      objectFit="contain"
                      w="40px"
                      h="40px"
                      src={seloClube}
                    />
                  </Box>
                ) : (
                  <Box w="40px" h="40px" />
                )}
                <Box filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
                  {seloClube && selopromocao ? (
                    <Box
                      background={clube ? getCorBgDestaqueSelo : "transparent"}
                      marginLeft="-0.5rem"
                      paddingY="0.25rem"
                      paddingX="0.30em"
                      borderTopRightRadius="md"
                      borderBottomRightRadius="md">
                      <Image
                        objectFit="contain"
                        w="40px"
                        h="40px"
                        src={seloClube}
                      />
                    </Box>
                  ) : (
                    <Box w="40px" h="40px" />
                  )}
                </Box>
              </Box>
              {ofertagenerica === "Y" && <ShareButton produto={props} />}
            </Box>
          ) : (
            <BoxVigencia
              props={{ validadede: validadede, validoapartir: validoapartir }}
            />
          )}
        </Box>
      </Box>
    </Container>
  );
}
